import React, { createContext, useCallback, useContext, useState } from 'react';

interface RateLimitState {
  isVisible: boolean;
  message: string;
  retryAfter: number;
}

interface RateLimitContextType {
  rateLimitState: RateLimitState;
  showRateLimit: (message: string, retryAfter: number) => void;
}

const RateLimitContext = createContext<RateLimitContextType | undefined>(
  undefined,
);

export const RateLimitProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [rateLimitState, setRateLimitState] = useState<RateLimitState>({
    isVisible: false,
    message: '',
    retryAfter: 0,
  });

  const showRateLimit = useCallback((message: string, retryAfter: number) => {
    setRateLimitState({
      isVisible: true,
      message,
      retryAfter,
    });
  }, []);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      (window as any).showRateLimitModal = showRateLimit;
    }
  }, [showRateLimit]);

  return (
    <RateLimitContext.Provider value={{ rateLimitState, showRateLimit }}>
      {children}
    </RateLimitContext.Provider>
  );
};

export const useRateLimit = () => {
  const context = useContext(RateLimitContext);
  if (!context) {
    throw new Error('useRateLimit must be used within a RateLimitProvider');
  }
  return context;
};
